export const SECURITY = 'SECURITY'
export default SECURITY;